class GiftNote extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.timeout = null;
    this.giftNoteCheckbox = this.querySelector('[name="add-gift-note"]');
    this.giftNote = this.querySelector('[name="gift-note"]');
    this.savedNote = this.querySelector("[data-saved-note]");

    this.cta = this.querySelector("[data-cta]");
    this.cta.addEventListener("click", () => {
      this.content.style.height = null;
      if (this.saved) {
        this.removeAttribute("saved");
      } else {
        this._setCartNote(this.giftNote.value);
        this.savedNote.innerHTML = this.giftNote.value;
        this.setAttribute("saved", "");
      }
    });

    this.enableInput = this.querySelector("[data-enable]");
    this.enableInput.addEventListener("change", () => {
      if (this.enableInput.checked) {
        this.removeAttribute("saved");
        this.open();
      } else {
        this.close();
        this._setCartNote(null);
        this.giftNote.value = "";
        this.savedNote.innerHTML = "";
      }
    });
  }

  open() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    if (this.content) {
      this.content.style.display = "block";
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
        this.style.borderColor = "transparent";
      });
    }
  }

  close() {
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.display = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
      this.style.borderColor = null;
    }
  }

  get content() {
    return this.querySelector("[data-content]");
  }

  get saved() {
    return this.hasAttribute("saved");
  }

  _setCartNote(note) {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      window.updateCart({
        attributes: {
          "Gift note": note,
        },
      });
    }, 500);
  }
}

if (!customElements.get("gift-note")) {
  customElements.define("gift-note", GiftNote);
}
